import { ApiDataResponse } from '@frontend/jetlend-core/src/models/api';
import { IAccountStatusDescription } from '@app/models/common/account';
import { apiGetRequest } from '@app/services/client/api';

export async function apiGetAccountStatuses(): Promise<ApiDataResponse<IAccountStatusDescription[]>> {
    return apiGetRequest('~/lend/api/account/statuses/public');
}
